<template>
	<div class="d-news-list-custom">
		<ListPageLayout
			v-if="true"
			ref="pageLayout"
			v-bind="{
				...$attrs,
				...$props,
			}"
			:search-config="{
				limit: 12,
			}"
			:hide-results-status="!computedFilters.text.value.length"
		>
			<!-- The search filters -->
			<template #filters="{ filters, filterValues, updateValue }">
				<div class="flex flex-col gap-layout-gutter mt-3xl">
					<BaseInputSearch
						v-if="filters.text"
						v-model="textValue"
						class="w-full >=1024:w-6/12col"
						v-bind="filters.text"
						@search="filters.text.value = $event"
					/>

					<div
						class="
							flex flex-col
							>=1024:flex-row
							w-full
							gap-layout-gutter
						"
					>
						<div class="flex gap-x-layout-gutter z-20">
							<BaseInputDropdown
								v-if="filters.year"
								id="newslist-year"
								class="flex-1 w-1/2 >=1024:w-3/12col z-20"
								v-bind="filters.year"
								:options="filters.year.value"
								:value="filterValues.year"
								@input="(value) => updateValue('year', value)"
							/>
							<BaseInputDropdown
								v-if="filters.month"
								id="newslist-month"
								class="flex-1 w-1/2 >=1024:w-3/12col z-10"
								v-bind="filters.month"
								:options="filters.month.value"
								:value="filterValues.month"
								@input="(value) => updateValue('month', value)"
							/>
						</div>

						<BaseInputDropdown
							v-if="filters.category"
							id="newslist-category"
							class="w-full >=1024:w-6/12col z-10"
							v-bind="filters.category"
							:options="filters.category.value"
							:value="filterValues.category"
							@input="(value) => updateValue('category', value)"
						/>
					</div>
				</div>
			</template>

			<template #resultsStatus="slotProps">
				Vi har fundet
				{{
					slotProps.pagination && slotProps.pagination.total
						? slotProps.pagination.total
						: 0
				}}
				nyhed{{
					slotProps.pagination && slotProps.pagination.total === 1
						? ''
						: 'er'
				}}
			</template>

			<template #results="{ data }">
				<template v-if="data && data.length > 0">
					<div
						v-if="!computedFilters.text.value.length"
						class="space-y-4xl"
					>
						<div
							v-for="[key, group] in formatItems(data)"
							:key="key"
						>
							<BaseH2 class="mb-xl" v-text="key" />

							<div
								:class="[
									'grid gap-layout-gutter',
									'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
								]"
							>
								<ContentCard
									v-for="item in group"
									:key="item.id"
									v-bind="{
										...item,
										link: { url: item.url },
										useFallbackImage: 1,
									}"
								/>
							</div>
						</div>
					</div>

					<div v-else>
						<div
							:class="[
								'grid gap-layout-gutter',
								'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
							]"
						>
							<ContentCard
								v-for="item in data"
								:key="item.id"
								v-bind="{
									...item,
									link: { url: item.url },
									useFallbackImage: 1,
								}"
							/>
						</div>
					</div>
				</template>
			</template>
		</ListPageLayout>

		<FeedbackModule
			v-if="!hideFeedback"
			:feedback="feedback"
			class="mt-7xl"
		/>
	</div>
</template>

<script>
import ListPageLayout from '~/components/shared/ListPageLayout';
import ContentCard from '~/components/shared/ContentCard';
import FeedbackModule from '~/components/shared/FeedbackModule';

const months = [
	'Januar',
	'Februar',
	'Marts',
	'April',
	'Maj',
	'Juni',
	'Juli',
	'August',
	'September',
	'Oktober',
	'November',
	'December',
];

export default {
	name: 'MainNewsListCustom',

	components: {
		ListPageLayout,
		ContentCard,
		FeedbackModule,
	},

	inheritAttrs: false,

	props: {
		hideFeedback: {
			type: Boolean,
			default: false,
		},
		feedback: Object,
		searchFilters: Object,
	},

	data() {
		return {
			year: null,
			month: null,
			category: null,
			textValue:
				this.searchFilters?.fields?.find((e) => e.name === 'text')
					.value || '',
		};
	},

	computed: {
		computedFilters() {
			const response = {};
			this.searchFilters?.fields?.forEach((element) => {
				response[element.name] = element;
			});

			return response;
		},
	},

	watch: {
		'computedFilters.text.value': {
			immediate: true,
			handler(value) {
				this.textValue = value;
			},
		},
	},
	methods: {
		formatItems(_items) {
			const items = _items.concat([]);
			items.sort((a, b) => {
				if (a.newsDate !== b.newsDate) {
					return (a.newsDate < b.newsDate) * 2 - 1;
				}

				return 0;
			});

			const response = {};
			items.forEach((item) => {
				const date = new Date(item.newsDate);
				const month = months[date.getMonth()];
				const year = date.getFullYear();
				const label = `${month} ${year}`;

				!response[label] && (response[label] = []);
				response[label].push(item);
			});

			return Object.entries(response);
		},
	},
};
</script>
